import { render, staticRenderFns } from "./liveRollCall.vue?vue&type=template&id=5b1630fa&scoped=true&"
import script from "./liveRollCall.vue?vue&type=script&lang=js&"
export * from "./liveRollCall.vue?vue&type=script&lang=js&"
import style0 from "./liveRollCall.vue?vue&type=style&index=0&id=5b1630fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1630fa",
  null
  
)

export default component.exports